import Vue from 'vue'
import VueRouter from 'vue-router'
import { isLoggedIn } from '@/utils/supervisorAuditAuth'

Vue.use(VueRouter)

/** 分销团队审核外挂（需登录，链接上带 ?team=团队展示ID） */
const SUPERVISOR_AUDIT_HOME_PATH = '/supervisorAudit'
/** 分销团队审核外挂 · 登录页 */
const SUPERVISOR_AUDIT_LOGIN_PATH = '/supervisorAudit/login'

const routes = [
  {
    path: '/recommender/purchase/:inviteCode',
    name: 'RecommenderPurchase',
    component: () => import('@/views/recommenderPurchase/index.vue')
  },
  {
    path: '/recommender/purchase',
    name: 'RecommenderPurchaseNoCode',
    component: () => import('@/views/recommenderPurchase/index.vue')
  },
  {
    path: SUPERVISOR_AUDIT_HOME_PATH,
    name: 'SupervisorAuditList',
    component: () => import('@/views/supervisorAudit/list.vue')
  },
  {
    path: '/supervisorAudit/detail',
    name: 'SupervisorAuditDetail',
    component: () => import('@/views/supervisorAudit/detail.vue')
  },
  {
    path: SUPERVISOR_AUDIT_LOGIN_PATH,
    name: 'SupervisorAuditLogin',
    component: () => import('@/views/supervisorAudit/login.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// 审核页登录态守卫：本地没有 token 或 token 已过期，一律回登录页（带上 ?team= 不丢）
router.beforeEach((to, from, next) => {
  if (!to.path.startsWith(SUPERVISOR_AUDIT_HOME_PATH)) {
    return next()
  }
  if (to.path === SUPERVISOR_AUDIT_LOGIN_PATH) {
    return isLoggedIn() ? next({ path: SUPERVISOR_AUDIT_HOME_PATH, query: to.query }) : next()
  }
  return isLoggedIn() ? next() : next({ path: SUPERVISOR_AUDIT_LOGIN_PATH, query: to.query })
})

// 浏览器/微信顶栏标题：审核外挂下统一显示「监管员审核」，其它页面保持产品名
const DEFAULT_TITLE = 'AI直播团队'
router.afterEach(to => {
  document.title = to.path.startsWith(SUPERVISOR_AUDIT_HOME_PATH) ? '监管员审核' : DEFAULT_TITLE
})

export default router
